import React, { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import PropTypes from "prop-types";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  Tooltip,
  TableRow,
  Alert,
  CircularProgress,
  IconButton,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Link } from "react-router-dom";
import {
  ActualizaMedicoBO,
  consultaMedicos,
} from "../../../services/MedicalStaffService";
import { Estados } from "../../../constants/estados";

export const MedicalStaffListResults = ({
  doctors,
  loading,
  setListDoctors,
  loadingData,
  ...rest
}) => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const getDoctorState = (state) => {
    return Estados[state];
  };

  return (
    <Card
      sx={{
        border: "0.5px solid #dddddd",
        padding: "1px",
        boxShadow: "1px 1px #d5d5d5",
      }}
      {...rest}
    >
        <Box sx={{ overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Apellido</TableCell>
                <TableCell>DNI</TableCell>
                <TableCell>Matrícula</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Acciones
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {!loading &&
                  doctors?.slice(page * limit, page * limit + limit)
                  .map((doctor) => (
                    <TableRow hover key={doctor.idMedico}>
                      <TableCell>{doctor.nombre}</TableCell>
                      <TableCell>{doctor.apellido}</TableCell>
                      <TableCell>{doctor.dni}</TableCell>
                      <TableCell>{`${doctor.tipoMatricula} - ${doctor.provinciaMatricula} - ${doctor.numeroMatricula}`}</TableCell>
                      <TableCell>{getDoctorState(doctor.estado)}</TableCell>

                      <TableCell>
                        <Box
                          sx={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Tooltip title="Ver detalles">
                            <Link
                              to={`/medical-staff/profile/${doctor.idMedico}`}
                            >
                              <IconButton
                                sx={{
                                  marginRight: "8px",
                                }}
                                color="primary"
                              >
                                <VisibilityOutlinedIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
              {!loading && (!doctors || doctors.length === 0) && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Alert severity="info">No hay médicos para aprobar</Alert>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>

      <Box
        sx={{
          alignItems: "center",
          padding: "10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {!!loading && (
          <div>
            <CircularProgress />
          </div>
        )}
      </Box>
      <TablePagination
        component="div"
        count={(doctors && doctors.length) || 0}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        labelRowsPerPage="Filas por página"
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Card>
  );
};

MedicalStaffListResults.propTypes = {
  doctors: PropTypes.array,
};
